import { GIFT_BOX_PRODUCT_TYPE } from '../config';
export const VARIANT_META_LOCAL_STORAGE_KEY = 'gift-wrapping:variant-meta';
const loadState = (key)=>{
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        return JSON.parse(raw);
    } catch (err) {
        return null;
    }
};
const saveState = (key, value)=>{
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
    // ignore
    }
};
const removeState = (key)=>{
    try {
        localStorage.removeItem(key);
    } catch (err) {
    // ignore
    }
};
// single consolidated export appended at file end
// Read the variant metafields JSON blob rendered on the page by
// snippets/product-details.liquid as `#gift-wrapping-product-variant-metafields`.
// Returns `{ [variantId]: { occupiedBoxSpace } }` or null.
const readVariantMetafieldsFromDOM = ()=>{
    try {
        const el = document.getElementById('gift-wrapping-product-variant-metafields');
        if (!el || !el.textContent) return null;
        const parsed = JSON.parse(el.textContent);
        var _parsed_variants;
        return (_parsed_variants = parsed === null || parsed === void 0 ? void 0 : parsed.variants) !== null && _parsed_variants !== void 0 ? _parsed_variants : null;
    } catch  {
        return null;
    }
};
// Listen for `cart:items-added` events and persist variant gifting metadata.
// Metafield data comes from the `#gift-wrapping-product-variant-metafields` DOM element
// rendered on PDP pages. For variants already in localStorage (e.g. added
// on a previous PDP visit) we preserve the existing entry.
const listenToItemsAdded = ()=>{
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    const handler = async ()=>{
        try {
            // Fetch the actual cart to get reliable item data
            const cartRes = await fetch('/cart.js');
            if (!cartRes.ok) return;
            const cart = await cartRes.json();
            if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;
            var _loadState;
            const existing = (_loadState = loadState(VARIANT_META_LOCAL_STORAGE_KEY)) !== null && _loadState !== void 0 ? _loadState : {};
            const domMeta = readVariantMetafieldsFromDOM();
            // Collect variant ids currently in the cart so we can prune stale entries
            const currentVariantIds = new Set();
            for (const item of cart.items){
                try {
                    const variantId = String(item.variant_id);
                    if (!variantId || variantId === '0') continue;
                    // Skip gift box products — they don't belong in the variant-meta mapping
                    if (item.product_type === GIFT_BOX_PRODUCT_TYPE) continue;
                    currentVariantIds.add(variantId);
                    // Look up this variant in the DOM-rendered metafields
                    const meta = domMeta ? domMeta[variantId] : null;
                    // If we have DOM metafield data for this variant, use it
                    if (meta) {
                        const toNum = (v)=>{
                            if (v == null || String(v).trim() === '') return null;
                            const n = Number(v);
                            return Number.isFinite(n) ? n : null;
                        };
                        const occupied = toNum(meta.occupiedBoxSpace);
                        const prevEntry = existing[variantId];
                        existing[variantId] = {
                            occupiedBoxSpace: (prevEntry === null || prevEntry === void 0 ? void 0 : prevEntry.occupiedBoxSpace) != null ? prevEntry.occupiedBoxSpace : occupied
                        };
                    } else if (!existing[variantId]) {
                        existing[variantId] = {
                            occupiedBoxSpace: null
                        };
                    }
                } catch (err) {
                // ignore per-item
                }
            }
            // Remove entries for variants no longer in the cart
            for (const key of Object.keys(existing)){
                if (!currentVariantIds.has(key)) delete existing[key];
            }
            saveState(VARIANT_META_LOCAL_STORAGE_KEY, existing);
        } catch (err) {
        // ignore
        }
    };
    window.addEventListener('cart:items-added', handler);
    return ()=>window.removeEventListener('cart:items-added', handler);
};
export { loadState, saveState, removeState, listenToItemsAdded };
